import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { msalInstance } from '..';
import { idp, idps } from '../App';
import { getAccessToken } from './authHelper';

const httpLink = new HttpLink({
    uri: `${process.env.REACT_APP_BACKEND_API_URL}/p/activity`,
});

const authLink = setContext(async (_, { headers }) => {
    const accessToken = (idp === idps.AAD)
        ? await getAccessToken(msalInstance)
        : localStorage.getItem('token');

    return {
        headers: {
            ...headers,
            Authorization: accessToken ? `Bearer ${accessToken}` : "",
        },
    };
});

export const client = new ApolloClient({
    link: ApolloLink.from([authLink, httpLink]),
    //   uri: `${process.env.REACT_APP_BACKEND_API_URL}/g/activity`,
    cache: new InMemoryCache(),
});